import { Link } from "react-router-dom";
import { languageHelper } from "../../../config/helperFunctions";

function Reporting() {
  const user = JSON.parse(localStorage.getItem("rms-admin"));
  const isSuperAdmin = user?.user?.role === "super-admin";

  const reportingData = [
    {
      name: languageHelper("Daily Sale Report"),
      path: "dailySaleReport",
    },
    {
      name: languageHelper("Detailed Sale Report"),
      path: "detailedSaleReport",
    },
    {
      name: languageHelper("Detailed Shift Report"),
      path: "detailedShiftReport",
    },
  ];

  const businessReport = [
    {
      name: languageHelper("Vat Report"),
      path: "vatReport",
    },
    {
      name: languageHelper("Multiple Vat Report"),
      path: "multipleVatReport",
    },
    ...(isSuperAdmin
      ? [
          {
            name: languageHelper("Overall report"),
            path: "overallReport",
          },
        ]
      : []),
    {
      name: languageHelper("Summary Report"),
      path: "summaryReport",
    },
    {
      name: languageHelper("Profit Loss Report"),
      path: "profitLossReport",
    },
    {
      name: languageHelper("Kitchen Performance Report"),
      path: "kitchenPerformanceReport",
    },
  ];

  const payableReport = [
    {
      name: languageHelper("Expense Report"),
      path: "expensesReport",
    },
    {
      name: languageHelper("Return Report"),
      path: "returnReport",
    },
    {
      name: languageHelper("Loyalty Points Report"),
      path: "loyaltyPointReport",
    },
    {
      name: languageHelper("Purchase Report"),
      path: "purchaseReport",
    },
    {
      name: languageHelper("Detailed Purchase Report"),
      path: "detailPurchaseReport",
    },
    {
      name: languageHelper("Customer Due Report"),
      path: "customerDueReport",
    },
    {
      name: languageHelper("Supplier Ledger"),
      path: "supplierLedgerReport",
    },

    {
      name: languageHelper("Customer Ledger"),
      path: "customerLedger",
    },

    {
      name: languageHelper("Supplier Due Report"),
      path: "supplierDueReport",
    },
  ];

  const activityReport = [
    {
      name: languageHelper("Register Report"),
      path: "registerReport",
    },
    {
      name: languageHelper("Rider Report"),
      path: "riderReport",
    },
    {
      name: languageHelper("Vendor report"),
      path: "vendorReport",
    },
    {
      name: languageHelper("Food Sale Report"),
      path: "foodSalesReport",
    },
    {
      name: languageHelper("Coupon Code Report"),
      path: "couponCodeReport",
    },
    {
      name: languageHelper("Waste Report"),
      path: "wasteReport",
    },
    {
      name: languageHelper("Attendance Report"),
      path: "attendanceReport",
    },
    {
      name: languageHelper("Low Inventory Report"),
      path: "lowInventoryReport",
    },

    {
      name: languageHelper("Consumption Report"),
      path: "consumptionReport",
    },

    {
      name: languageHelper("Inventory Report"),
      path: "inventoryReport",
    },
  ];

  return (
    <main className="my-16">
      <div>
        <h1 className="text-d-bg-text text-2xl font-medium pt-4">
          {languageHelper("Reporting")}
        </h1>
      </div>
      <div className="relative my-8 flex flex-col min-w-0 break-words w-full mb-6 shadow-lg bg-white rounded-lg p-4 border-0">
        <div className="flex flex-col lg:flex-row gap-y-2 w-full py-3">
          <div className="w-full lg:w-1/3">
            <h1 className=" text-d-bg-text text-lg">
              {languageHelper("Sales")}
            </h1>
            {reportingData &&
              reportingData.map((data) => (
                <Link to={data.path} target="_blank">
                  <h1 className="text-sm text-blue-400 pt-2 hover:text-d-bg-text">
                    {data.name}
                  </h1>
                </Link>
              ))}
          </div>

          <div className="w-full lg:w-1/3">
            <h1 className=" text-d-bg-text text-lg">
              {languageHelper("Business Overview")}
            </h1>
            {businessReport &&
              businessReport.map((data) => (
                <Link to={data.path} target="_blank">
                  <h1 className="text-sm text-blue-400 pt-2 hover:text-d-bg-text">
                    {data.name}
                  </h1>
                </Link>
              ))}
          </div>

          <div className="w-full lg:w-1/3">
            <h1 className=" text-d-bg-text text-lg">
              {languageHelper("Payables and Receivables")}
            </h1>
            {payableReport &&
              payableReport.map((data) => (
                <Link to={data.path} target="_blank">
                  <h1 className="text-sm text-blue-400 pt-2 hover:text-d-bg-text">
                    {data.name}
                  </h1>
                </Link>
              ))}
          </div>

          <div className="w-full lg:w-1/3">
            <h1 className=" text-d-bg-text text-lg">
              {languageHelper("Activity")}
            </h1>
            {activityReport &&
              activityReport.map((data) => (
                <Link to={data.path} target="_blank">
                  <h1 className="text-sm text-blue-400 pt-2 hover:text-d-bg-text">
                    {data.name}
                  </h1>
                </Link>
              ))}
          </div>
        </div>
      </div>
    </main>
  );
}
export default Reporting;
